/**
 * Shopify Cart Drawer Module
 * Complete cart drawer functionality for Shopify themes
 */

(function(theme, $) {
  'use strict';

  // Cart Drawer Configuration
  theme.cartDrawer = {
    config: {
      cartUpdatingRemoveTimeout: -1,
      useSideCartSummary: theme.useSideCartSummary || 'on',
      cartType: theme.settings.cartType || 'drawer'
    }
  };

  // Main Cart Drawer Section Handler
  theme.CartDrawerSection = new function() {
    this.onSectionLoad = function(container) {
      theme.applyAjaxToProductForm($('.product-form', container));
      theme.loadCartNoteMonitor(container);

      var $body = $('body');
      var $window = $(window);

      function assessScrollPosition() {
        if ($window.scrollTop() === 0) {
          $body.addClass('scrolled-top');
        } else {
          $body.removeClass('scrolled-top');
        }
      }
      assessScrollPosition();

      if (theme.viewport.isSm()) {
        $(window).on('throttled-scroll.cartDrawer', assessScrollPosition);
      }

      // Handle clear cart
      $(container).on('click', '.btn--empty-cart', function() {
        if (confirm(theme.strings.confirmEmptyCart)) {
          $(container).find('.cart-summary-item-container').each(function(index) {
            setTimeout(() => {
              $(this).addClass('cart-summary-item-container--out');
            }, index * 50);
          });

          $.post(theme.routes.cart_clear_url, function() {
            theme.updateCartSummaries(false, false);
          });
        }
        return false;
      });

      // Accordions
      $(container).on('click', '.cart-accordion-btn', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var isHidden = $(this).parent()
          .next()
          .toggleClass('hidden')
          .hasClass('hidden');
        $(this).toggleClass('cart-accordion-btn--collapsed', isHidden);
        if (!isHidden) {
          $(this).closest('.cart-summary')
            .find('.cart-accordion-btn:not(.cart-accordion-btn--collapsed)')
            .not(this)
            .click();
        }
      });

      $(container).on('click', '.cart-accordion-btn-container', function(e) {
        e.preventDefault();
        $(this).find('.cart-accordion-btn').click();
      });

      // Compensate for cart notes in sticky header
      function updateStickyDrawerHeader() {
        var $cartForm = $('.cart-form--checkout', container);
        var $cartFormNonStick = $('.cart-form--non-stick', container);

        if ($cartForm.hasClass('cart-form--checkout--sticky-true') && $cartFormNonStick.length) {
          $cartForm.css('top', -Math.abs(parseInt($cartFormNonStick.outerHeight() + 1)) + 'px');
        }
      }

      updateStickyDrawerHeader();
      $(window).on('debouncedresize.cartDrawer cc-cart-updated', updateStickyDrawerHeader);
    };

    this.onSectionUnload = function(container) {
      theme.removeAjaxFromProductForm($('form.product-form', container));
      theme.unloadCartNoteMonitor(container);
      $(window).off('.cartDrawer');
    };

    this.onSectionSelect = function(container) {
      // Display drawer
      if (!$('body').hasClass('show-cart-summary')) {
        $('.toggle-cart-summary:first').click();
      }
    };

    this.onSectionDeselect = function(container) {
      // Hide drawer
      if ($('body').hasClass('show-cart-summary')) {
        $('.toggle-cart-summary:first').click();
      }
    };
  }();

  // Main Cart Update Function
  theme.updateCartSummaries = function(showCartSummary, isAddToCart, delayQtyAdjusterShow) {
    theme.cartLoadingStarted();
    
    var itemListScrollTop = $('.cart-summary__item-list:first').scrollTop();
    var cartDrawerInnerScrollTop = $('.cart-summary__inner:first').scrollTop();
    
    $.get(theme.routes.search_url, function(data) {
      var selectors = [
        '.toolbar-cart .current-cart',
        '.cart-summary'
      ];

      var $parsed = $($.parseHTML('<div>' + data + '</div>')).wrap('<div>').parent();
      
      for (var i = 0; i < selectors.length; i++) {
        var cartSummarySelector = selectors[i];
        var $newCartObj = $parsed.find(cartSummarySelector).clone();
        
        // Remove fade-in classes
        $newCartObj.find('.fade-in').removeClass('fade-in');
        var $currCart = $(cartSummarySelector);

        // Maintain button container height
        var $buttonContainer = $newCartObj.find('.cart-summary__buttons');
        if ($buttonContainer.length) {
          $buttonContainer.css('height', $currCart.find('.cart-summary__buttons').outerHeight() + 'px');
        }

        var $newCartItem = $newCartObj.find('.cart-summary-item-container').eq(0);

        // Check if item already exists
        if ($currCart.find('.cart-summary-item-container[data-product-id="' + 
            $newCartItem.data('product-id') + '"]').length) {
          isAddToCart = false;
        }

        if (isAddToCart && $newCartItem.length) {
          $newCartItem.addClass('cart-summary-item-container--out-left').hide();
        }

        var $cartForm = $('.cart-form--checkout', $currCart);
        var $cartFormNonStick = $('.cart-form--non-stick', $currCart);

        if ($cartForm.hasClass('cart-form--checkout--sticky-true') && $cartFormNonStick.length) {
          $newCartObj.find('.cart-form--checkout')
            .css('top', -Math.abs(parseInt($cartFormNonStick.outerHeight() + 1)) + 'px');
        }

        $currCart.replaceWith($newCartObj);

        if (isAddToCart && $newCartItem.length) {
          $newCartItem.slideDown(300);
          $newCartItem.removeClass('cart-summary-item-container--out-left');
        }

        if ($buttonContainer.length) {
          setTimeout(function() {
            $(cartSummarySelector).find('.cart-summary__buttons').css('height', 'auto');
          }, 1000);
        }
      }

      var cartItemData;

      if ($('#LimitedCartJson').length) {
        cartItemData = JSON.parse($('#LimitedCartJson').html());

        if (delayQtyAdjusterShow) {
          setTimeout(() => {
            theme.loadInPlaceQuantityAdjustment($('body'), cartItemData);
          }, 800);
        } else {
          theme.loadInPlaceQuantityAdjustment($('body'), cartItemData);
        }

        theme.applyAjaxToProductForm($('.cart-summary form.product-form'));
      }
      
      theme.loadCartNoteMonitor($('.cart-summary'));

      $('.cart-summary__item-list:first').scrollTop(itemListScrollTop);
      $('.cart-summary__inner:first').scrollTop(cartDrawerInnerScrollTop);

      if (theme.cartDrawer.config.cartType != 'page') {
        // Show cart dropdown
        if (showCartSummary) {
          setTimeout(function() {
            $('body').addClass('show-cart-summary product-added-to-cart');
            setTimeout(function() {
              $('.cart-summary__close').focus();
            }, 200);
          }, 20);
        }
        
        // Remove updating classes
        $('.cart-summary.updating, .cart-summary .updating').removeClass('updating');

        if (cartItemData) {
          $(window).trigger('cc-cart-updated', {
            cartItemData: cartItemData
          });
        }
      }
    }).always(function() {
      theme.cartLoadingFinished();
    });
  };

  // Initialize Cart Drawer Events
  theme.initCartDrawer = function() {
    // Cart drawer toggle handler
    if (theme.cartDrawer.config.useSideCartSummary != 'off') {
      $(document).on('click', '.toggle-cart-summary', function() {
        if ($('.cart-summary .toggle-cart-summary').is(':visible')) {
          $('#mobile-nav').removeClass('active');
          $('.cart-summary').addClass('active');
          $('body').removeClass('product-added-to-cart');
          
          if (!$('body').toggleClass('show-cart-summary').hasClass('show-cart-summary')) {
            // Cart closed
          } else {
            setTimeout(function() {
              $('.cart-summary__close').focus();
            }, 200);
          }
          return false;
        }
      });
    }

    // Remove item handler
    $(document).on('click', '.qty-adjuster--ajax .qty-adjuster__remove', function(e) {
      e.preventDefault();
      $(this).closest('.qty-adjuster').find('.qty-adjuster__value').val(0).trigger('change');

      var $cartItem = $(this).closest('.cart-summary-item-container');
      $cartItem.addClass('cart-summary-item-container--out');
      $cartItem.slideUp(300);
    });

    // Overlay click handler (close cart)
    $(document).on('click', '#page-overlay, .side-menu-header--close', function() {
      $('body').removeClass('show-cart-summary show-mobile-nav product-added-to-cart');
      return false;
    });

    // Check if drawer functionality should be enabled
    if (theme.cartDrawer.config.cartType.includes('drawer')) {
      // Additional drawer-specific initialization
      console.log('Cart drawer functionality enabled');
    }
  };

  // Register the cart drawer section
  theme.registerCartDrawer = function() {
    if (theme.Sections && theme.Sections.register) {
      theme.Sections.register('cart-drawer', theme.CartDrawerSection, { 
        deferredLoad: false 
      });
    }
  };

  // Auto-initialize on DOM ready
  $(document).ready(function() {
    theme.initCartDrawer();
    theme.registerCartDrawer();
  });

// varient url
  const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');

  variantInputs.forEach(input => {
    input.addEventListener("change", function () {

      let variantId = this.value;

      if (variantId) {
        let newUrl = window.location.pathname + '?variant=' + variantId;
        window.history.replaceState({}, '', newUrl);
      }

    });

});

})(window.theme = window.theme || {}, jQuery);